import {
    Badge,
    Group,
    Paper,
    Text,
} from '@mantine/core';

import {
    DefectSummary,
    LIVE_WINDOW_HOURS,
} from '../utils/summarizeDefects';

// The state of the fleet, stated before the table.
//
// LIVE leads deliberately. Total signature count grows monotonically with
// history and is a weak health signal on its own — it will exceed any threshold
// eventually and that will be correct. "How many things are wrong right now" is
// the number an operator opens this page to ask, and it is the same reasoning
// that shaped FNP-903's Done-when box ("≤ 20 signatures, of which ≤ 3 live").
export const DefectSummaryStrip = ({summary}: { summary: DefectSummary }) => {

    const entries: { label: string, value: number, color: string, hint: string }[] = [
        {
            label: 'Live',
            value: summary.live,
            color: summary.live > 0 ? 'red' : 'green',
            hint: `Seen within the last ${LIVE_WINDOW_HOURS} hours — what is broken right now.`,
        },
        {
            label: 'Unverified effect',
            value: summary.unverifiedEffect,
            color: 'orange',
            hint: 'The action appeared to succeed but the platform did not record it. Every confirmed product bug so far arrived this way.',
        },
        {
            label: 'Regressions',
            value: summary.regressions,
            color: 'red',
            hint: 'Resolved, then seen again. These are NOT fixed.',
        },
        {
            label: 'Unfiled',
            value: summary.unfiled,
            color: 'blue',
            hint: 'No Jira ticket yet, and not resolved — outstanding triage.',
        },
        {
            label: 'Resolved',
            value: summary.resolved,
            color: 'green',
            hint: 'Stopped recurring. Concluded by the sweep from an absence of occurrences, not by a human.',
        },
    ];

    return (
        <Paper withBorder p={'md'} radius={'md'}>
            <Group justify={'space-between'} align={'center'} wrap={'wrap'}>
                <Group gap={'lg'} wrap={'wrap'}>
                    {entries.map((entry) => (
                        <Group key={entry.label} gap={'xs'} title={entry.hint}>
                            <Badge color={entry.color} variant={'light'}>{entry.value}</Badge>
                            <Text size={'sm'}>{entry.label}</Text>
                        </Group>
                    ))}
                </Group>
                <Text size={'xs'} c={'dimmed'}>
                    {summary.total === 1
                        ? '1 distinct defect signature'
                        : `${summary.total} distinct defect signatures`}
                </Text>
            </Group>
        </Paper>
    );
};
